






















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Order } from "@foxone/api/src/models/defi";
import utils from "defi/utils";

@Component
class OrderItem extends Vue {
  @Prop() order!: Order;

  @Prop() last!: boolean;

  @Prop() first!: boolean;

  get meta() {
    return {
      id: this.order.id,
      quantity: this.order.pay_amount,
      icon: this.order.pay_asset.icon,
      name: this.order.contract.name,
      symbol: this.order.pay_asset.symbol.toUpperCase(),
      status: utils.enums.getOrderStatusMeta(this.order.status)
    };
  }
}
export default OrderItem;
